<template>
    <div class="gh-page gh-page--mcd">
        <section class="gh-section">
            <div class="container">
                <h1 class="gh-section__heading">Generate Your CE Certificate of Attendance</h1>
                <p>Thank you for attending the {{ eventTitle }}. Via this page you can generate a CE Certificate of Attendance for each {{ eventTitle }} session you've attended (either by joining the live webinar, or by watching the session recording). To generate a Certificate:</p>
                <ol>
                    <li>Select the title of the session</li>
                    <li>Enter your email address (this must be the <u>same</u> email you used to register for the {{ eventTitle }})</li>
                    <li>Tick the declaration box</li>
                    <li>Click the "Get Certificate" button. Upon completing this process, the system will generate a PDF Certificate, which you can save to your computer. If you experience any issues with the process, <a href="mailto:admin@mentalhealthacademy.net">email us</a> for further assistance.</li>
                </ol>

                <transition name="el-fade-in">
                    <div v-show="errorMessage"
                         v-html="errorMessage"
                         class="gh-form__response is-error">
                    </div>
                </transition>

                <div class="gh-form" v-loading.fullscreen.lock="form.processing" element-loading-text="Generating Certificate">
                    <div class="gh-form__wrapper">
                        <el-form
                                :model="form"
                                :rules="form.validationRules"
                                @keyup.enter.native="attemptSubmit('elForm')"
                                ref="elForm"
                                class="gh-form__content">
                            <!-- Profile -->
                            <div class="gh-form__group">
                                <el-form-item prop="session">
                                    <label class="gh-form__label">Select Session Title</label>
                                    <el-select v-model="form.session">
                                        <el-option
                                            v-for="session in sessions"
                                            :key="session"
                                            :label="session"
                                            :value="session">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="gh-form__group">
                                <el-form-item prop="email">
                                    <label class="gh-form__label">Confirm Your Email Address</label>
                                    <el-input v-model="form.email" type="email" name="email"></el-input>
                                </el-form-item>
                            </div>

                            <div class="gh-form__group">
                                <el-form-item prop="attendanceConfirm" class="c-form__item c-form__tnc">
                                    <el-checkbox v-model="form.attendanceConfirm">
                                        I hereby declare that I have attended/watched this session.
                                    </el-checkbox>
                                </el-form-item>
                            </div>

                            <!-- Actions -->
                            <div class="gh-form__actions">
                                <el-button class="gh-button-redesign gh-button--cta" @click="attemptSubmit('elForm')"
                                           :disabled="form.processing">
                                    Get Certificate
                                </el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
  import formMixin from '@/modules/form/mixins/form'
  import Form from '@/modules/form/models/Form';

  export default {
    name: 'GhSuicidePreventionCertificate',

    mixins: [formMixin],

    data() {
      return {
        errorMessage: '',
        isFetching: true,
        form: new Form({
          session: null,
          email: null,
          attendanceConfirm: false,
        })
      }
    },

    async created () {
      await this.fetchSessions()
    },

    computed: {
      eventId () {
        return 2;
      },

      sessions () {
        return _.chain(this.$store.state.event.eventSessions)
          .toArray()
          .flatten()
          .map(item => item.title)
          .value()
      },

      eventTitle() {
        return 'Suicide Prevention Summit'
      }
    },

    methods: {
       async fetchSessions () {
        this.isFetching = true

        await this.$store.dispatch('event/getSessions', this.eventId)

        this.isFetching = false
      },

      attemptSubmit(formName) {
        this.errorMessage = ''
        this.$refs[formName].validate((valid) => {
          if (! valid) {
            this.scrollToError(formName);
            return false;
          }

          this.form.processing = true;

          this.handleSubmit();
        });
      },

      async handleSubmit () {
          await this.$store.dispatch(
            'event/isDownloadable',
            { event_id: this.eventId, email: this.form.email, session: this.form.session})
          .then( data => {
              window.open( data.downloadUrl, '_blank');
              this.form.processing = false;
          })
          .catch(({response}) => {
            this.form.processing = false;

             this.$msgbox({
                  message: `Please use the same email you used to register for the ${this.eventTitle}`,
                  type: 'error',
                  title: 'Invalid email address',
                  confirmButtonText: 'OK',
            });
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
    ol {
        padding-left: 1rem;
        color: #333;
        font-size: 18px;
        font-weight: 500;
    }

    .gh-form {
        max-width: 680px;
        margin-top: 2rem;
    }

    .gh-form__actions {
        margin-top: 2rem;
    }

    .gh-button--cta {
      color: white;
    }
</style>